// const BASE_URL = "http://localhost";
const BASE_URL = "https://ultravux.com/api";
// const BASE_URL1 = "http://localhost:3000/";


export default BASE_URL;
// export default BASE_URL;